import { Kitchen, DirectionsCar, Ballot } from "@mui/icons-material";

export const iconMapper = {
  bathtub: Ballot,
  kitchen: Kitchen,
  garage: DirectionsCar,
};
